import ObjectToBase64 from '@/utils/objectToBase64';
import router from '@/router';

class LS {
  set(key, value) {
    return localStorage?.setItem(key, value);
  }

  get(key) {
    return localStorage?.getItem(key);
  }

  del(key) {
    return localStorage?.removeItem(key);
  }
}

const ls = new LS();
const LS_KEY = 'pl';
const QUERY_KEY = 'pl';

/**
 * flush 如果在watchQueryChange事件触发前，想获取位置信息，get之前flush一下
 * watchQueryChange 监听路由变化，更新位置信息
 * set 手动设置地理位置信息，入参为对象
 * get 获取地理位置信息
 *
 * 参考资料：
 * url 长度限制 http://net-informations.com/q/mis/len.html；简单来说，保证在2000个字符以下
 */
class AddressMonitor {
  constructor() {
    this.state = new ObjectToBase64();
    this.storage = ls;
  }

  flush() {
    const storageBase64Str = this.storage.get(LS_KEY);
    if (this._validateStorage(storageBase64Str)) {
      this._initStateByBase64Str(storageBase64Str);
    }
  }

  watchQueryChange(query) {
    const queryBase64Str = query[QUERY_KEY];
    const storageBase64Str = this.storage.get(LS_KEY);

    let queryBase64StrIsValid = this._validateQuery(queryBase64Str);
    let storageBase64StrIsValid = this._validateQuery(storageBase64Str);

    // if (queryBase64StrIsValid) {
    //   this._setStorage(queryBase64Str);
    // } else {
    //   if (this._validateStorage(storageBase64Str)) {
    //     this._setQuery(storageBase64Str, query);
    //   }
    // }

    if (storageBase64StrIsValid) {
      this._setQuery(storageBase64Str, query);
      return;
    }

    if (queryBase64StrIsValid) {
      this._setStorage(queryBase64Str);
      return;
    }
    // TODO URL和本地缓存信息都失效时的处理逻辑
  }

  _initStateByBase64Str(base64Str) {
    this.state.setBase64String(base64Str);
  }

  _initStateByObject(object) {
    this.state.setObject(object);
  }

  set(object) {
    this._initStateByObject(object);
    const base64Str = this.state.getBase64Str();
    this._setQuery(base64Str);
    this._setStorage(base64Str);
  }

  get() {
    return this.state.getObject();
  }

  _setQuery(base64Str, restQuery) {
    const currentQuery = router?.app?._route?.query || {};
    const currentHash = router?.app?._route?.hash || '';
    restQuery = restQuery || currentQuery;
    router.replace(
      { query: { ...restQuery, pl: base64Str }, hash: currentHash }).
      catch(err => {
        // console.log('=========== AddressMonitor router replace err ===========', err);
      });
    this._initStateByBase64Str(base64Str);
  }

  _validateQuery(base64Str) {
    return this.state.isValidBase64Str(base64Str);
  }

  _setStorage(base64Str) {
    this.storage.set(LS_KEY, base64Str);
    this._initStateByBase64Str(base64Str);
  }

  _validateStorage(base64Str) {
    return this.state.isValidBase64Str(base64Str);
  }
}

const addressMonitor = new AddressMonitor();

export default addressMonitor;
